var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-4" },
    [
      _c("div", { staticClass: "form-group mb-0" }, [
        _c("label", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.label))])
      ]),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c("div", { key: option.value, staticClass: "form-check" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: { type: "checkbox", name: _vm.name, id: option.label },
            domProps: {
              value: option.value,
              checked: _vm.value.includes(option.value)
            },
            on: {
              click: function($event) {
                return _vm.updateValue($event.target)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: option.label } },
            [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/MultiCheckboxField.vue?vue&type=template&id=5d606790&
// module id = 387
// module chunks = 0